<template>
  <div>

    <div class="row carousel-container" :class="{ 'carouselCreated': carouselCreated }">

      <div class="mx-auto d-none d-lg-block carousel-controls" :class="controlsSize">
        <button class="btn btn-light-dark ml-n4 d-inline-flex align-items-center" @click="carouselControl('prev')">
          <chevron-left-icon class="h1 m-0 text-white" />
        </button>

        <button class="btn btn-light-dark mr-n4 float-right d-inline-flex align-items-center" @click="carouselControl('next')">
          <chevron-right-icon class="h1 m-0 text-white" />
        </button>
      </div>

      <div class="carousel-nav">
        <button class="btn btn-light-dark btn-sm" v-for="i in 5"> </button>
      </div>

      <div class="col-12 px-0">
        <div class="carousel-itens">

          <slot></slot>

        </div>
      </div>

    </div>

  </div>
</template>

<script>
  import ChevronLeftIcon from "vue-material-design-icons/ChevronLeft.vue"
  import ChevronRightIcon from "vue-material-design-icons/ChevronRight.vue"

  export default {
    name: 'Slider',

    data(){
      return {
        carousel: null,
        carouselCreated: false
      }
    },

    props: {
      responsive: Object,
      controlsSize: {
        type: String,
        default: 'col-11 col-md-10 col-lg-10 col-xl-10'
      }
    },

    components: {
      ChevronLeftIcon,
      ChevronRightIcon
    },

    methods: {
      carouselControl(direction){
        this.carousel.goTo(direction);
      }
    },

    beforeDestroy() {
      this.carousel.destroy();
    },

    mounted(){
      let _ctx = this;

      this.carousel = this.$carousel({
        container: '.carousel-itens',
        autoWidth: false,
        slideBy: 1,
        gutter: 20,
        mouseDrag: true,
        controls: false,
        navContainer: '.carousel-nav',

        responsive: this.responsive,

        onInit: function(){
          _ctx.carouselCreated = true;
        }
      });

    }
  }
</script>

<style lang="scss" scoped>
  .carousel-container{
    position: relative;

    &:not(.carouselCreated){
      display: none;
    }

    .carousel-itens{
      display: flex;
    }

    .carousel-controls{
      height: 0px;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -110px);
      z-index: 1;

      button{
        padding: 0;
        height: 80px;
      }
    }

    .carousel-nav{
      width: 100%;
      position: absolute;
      bottom: -20px;
      display: flex;
      justify-content: center;

      .btn{
        width: 10%;
        margin: 0 5px;
        &.tns-nav-active{
          background-color: theme-color-level('light-dark', 1);
        }
      }
    }
  }
</style>